const styles = {
  root: {
    paddingBottom: 24,
    '& .info-card': {
      position: 'relative',
      background: '#FDF2ED',
      borderRadius: 8,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      '& .info': {
        padding: 16,
        '& .value': {
          fontSize: 24,
        },
        '& .desc': {

        },
      },
    },
    '& .product-box': {
      boxShadow: '0px 4px 16px rgba(22, 21, 81, 0.2)',
      borderRadius: 8,
      overflow: 'hidden',
      minHeight: 228,
      cursor: 'pointer',
      position: 'relative',
      '& .verified': {
        position: 'absolute',
        top: 4,
        left: 4,
      },
      '& .product-cover': {
        width: '100%',
        height: 140,
        objectFit: 'cover',
      },
      '& .product-info': {
        padding: 8,
        marginTop: -20,
        '& .category': {
          padding: '2.5px 8px 2.5px 2.5px',
          background: '#ECF5F8',
          color: '#282828',
          borderRadius: 25,
          gap: 4,
        },
      },
    },
  },
};

export default styles;
